module.exports = __webpack_public_path__ + "static/6-7839dd116260153f5bbbc0f67d38462e.png";